module.exports = __webpack_public_path__ + "img/rules-warning-sign.db90575c.jpg";